import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetcAboutpage, fetchHomepage, fetchServices } from "../Redux/slice/homeSlice";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";

const AboutRap = styled.div`
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1c4b42;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1c4b42;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 709px;
  }
  h2 {
    color: #1c4b42;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }

  .about-1-upper,
  .about-2-upper-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .about-1 img {
    width: 100%;
    height: auto;
    border-radius: 24px;
  }
  .about-1 {
    display: flex;
    flex-direction: column;
    gap: 50px;

    background: linear-gradient(180deg, #f6f5f2 0%, #ffffff 100%);
    padding-top: 160px;
  }
  .about-2-upper p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 509px;
    line-height: 22px;
  }
  .about-2-upper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
  .card-2-upper {
    background: #b4e717;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    display: flex;
    margin-left: 20px;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
  }
  .card-2-down h4 {
    color: #1c4b42;
    font-weight: 500;
    font-size: 22px;
  }
  .card-2-down p {
    max-width: 229px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    color: #000000cc;
  }
  .card-2-down {
    background: #f6f5f2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding: 30px 20px;
    padding-bottom: 50px;
    border-radius: 16px;
  }
  .about-2-card {
    border: 1px solid #0000001a;
    padding: 20px;
    border-radius: 24px;
   gap: 50px;
    width: 290px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .about-2-card:hover {
     background: #b4e717;
  }
  
  .about-2-down {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-content: space-between;
  }
  .about-2 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-top: 100px;
  }
  .about-3-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .about-3-upper h2 {
    text-align: center;
  }
  .about-3-down-img {
  }
  .about-2-card-circle {
    width: 52px;
    height: 52px;
    background: #b4e717;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .about-2-card-circle i {
    color: #1c4b42;
  }
  .about-2-card:hover .about-2-card-circle {
    background: #1c4b42;
  }
  .about-2-card:hover .about-2-card-circle i {
    color: #b4e717;
  }
  .link {
    backdrop-filter: blur(40px);
    background: #ffffff33;
    height: 47px;
    width: 90px;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 10px;
    color: #000000cc;
    font-size: 11px;
    font-weight: 500;
    border-radius: 16px;
  }
  .link.active {
    background: #ffffff;
  }
  .about-3-Links {
    display: flex;
    gap: 10px;
  }
  .about-3-down {
    margin-top: 100px;
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    padding-bottom: 50px;
    gap: 20px;
    justify-content: space-between;
    align-items: flex-end;
  }
  .card-3-upper-left h3 {
    color: #1c4b42;
    font-size: 30px;
    font-weight: 500;
  }
  .card-3-img {
    width: 42px;
    height: 42px;
    border-radius: 100px;
  }
  .card-3-upper {
    display: flex;
    justify-content: space-between;
  }
  .about-3-card p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    max-width: 420px;
  }
  .about-3-card {
    background: #ffffffcc;
    backdrop-filter: blur(40px);
    width: 640px;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    border-radius: 24px;
  }
  .about-3 {
    margin-top: 100px;
  }
  .left-4-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .left-4-upper h2 {
    max-width: 450px;
  }
  .left-4-btn {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background: #1c4b42;
    height: 47px;
    width: 175px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 100px;
  }
  .card-6-down {
    width: fit-content;

  }
  .card-6-down:hover .left-4-btn {
    background: #f6f5f2;
    color: #1c4b42;
  }
   .left-4-down {
    width: fit-content;

  }
  .left-4-down:hover .left-4-btn {
    background: #b4e717;
    color: #1c4b42;
  }
  .left-4-circle {
    width: 47px;
    height: 47px;
    border-radius: 100px;
    display: flex;
    background: #1c4b42;
    justify-content: center;
    align-items: center;
  }
   .left-4-circle svg {
    color: #b4e717;
   }
   .card-6-down:hover .left-4-circle {
    background: #f6f5f2;
    color: #1c4b42;
  }
   .card-6-down:hover .left-4-circle svg {
    
    color: #1c4b42;
  }

    .left-4-down:hover .left-4-circle {
    background: #b4e717;
    color: #1c4b42;
  }
   .left-4-down:hover .left-4-circle svg {
    
    color: #1c4b42;
  }
  .left-4-down {
    display: flex;
  }
  .about-4-left {
    display: flex;
    flex-direction: column;
    gap: 70px;
  }
  .right-4-circle {
    background: #b4e717;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    display: flex;
    padding: 20px;
    justify-content: center;
    align-items: center;
  }
  .about-4-right p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    max-width: 506px;
  }
  .about-4-right {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .about-4 {
    margin-top: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
  .about-5-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    border-radius: 100px;
    width: 24px;
    background: #1c4b42;
  }
  .about-5-link {
    height: 56px;
    text-decoration: none;
    padding: 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #f6f5f2;
    color: #1c4b42;
    font-size: 18px;
    font-weight: 500;
    border-radius: 100px;
  }
  .about-5-link:hover {
    background: #b4e717;
  }
  .about-5 {
    margin-top: 100px;
    border-top: 1px solid #0000001a;
    padding-top: 40px;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .icon-6-img {
    width: 45px;
    height: 45px;
  }
  .card-6-middle p {
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    max-width: 345px;
    color: #000000cc;
  }
  .person-img {
    width: 50px;
    height: 50px;
    border-radius: 100px;
  }
  .card-6-sub h4 {
    font-weight: 500;
    font-size: 18px;
    color: #1c4b42;
  }
  .card-6-sub h5 {
    font-weight: 500;
    font-size: 11px;
    color: #1c4b42;
  }
  .card-6-sub,
  .card-6-middle {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .card-6-middle {
    gap: 15px;
  }
  .card-6-inner {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .about-6-card {
    width: 413px;
    height: 550px;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    background: #b4e717;
  }
  .card-6-down {
    display: flex;
  }
  .about-6-box h4 {
    max-width: 324px;
    color: #b4e717;
    font-size: 30px;
    line-height: 36px;
    font-weight: 500;
  }
  .box-6-down img {
    width: 20px;
    height: 20px;
  }
  .box-6-down p {
    font-weight: 400;
    color: #b4e717;
    font-size: 11px;
  }
  .box-6-down {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .about-6-box {
    background: #1c4b42;
    border-radius: 24px;
    width: 413px;
    height: 550px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }
  .box-6-cut-img {
    width: 345px;
    height: 333px;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .about-6-image {
    border-radius: 24px;
    max-width: 413px;
    height: 550px;
  }
  .about-6 {
    display: flex;
    gap: 10px;
    margin: 100px 0px;
    justify-content: space-between;
  }
   @media (max-width: 1250px) {
    .about-2-card {
      width: 280px;
    }
   }
     @media (max-width: 1200px) {
    .about-2-card {
      width: 305px;
    }
    .about-2-down {
   
    grid-template-columns: repeat(3, 1fr);
     }
   }
  @media (max-width: 1170px) {
    .about-6 {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 992px) {
    /* h1 {
      font-size: 45px;
    }
    h2 {
      font-size: 40;
    } */
    .about-2-down {
   
    grid-template-columns: repeat(2, 1fr);
     }
    .about-2-upper,
    .about-2-down {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 700px) {
    
    h1 {
      font-size: 32px !important;
    line-height: 40px !important;
    }
      h2 {
    font-size: 28px !important;
    line-height: 32px !important;
  }
   .about-2-down {
   
    grid-template-columns: repeat(1, 1fr);
     }
    /* .about-1,
    .about-1-upper {
      align-items: center;
    } */
    /* h1 {
      text-align: center;
    } */
    .about-3-down {
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
    }
    .about-3-card {
      width: 100%;
    }
    .about-3-Links {
      flex-wrap: wrap;
    }
    .about-4 {
      flex-direction: column;
      align-items: flex-start;
    }
      .about-5-link {
      align-items: center;
      justify-content: space-between;
    }
     .about-2-card,
    .about-5-link,
    .about-6-card,
    .about-6-image,
    .about-6-box {
      width: 100%;
    }
    .about-6-image {
      max-width: 100%;
      height: auto;
    }
  }


  @media (max-width: 500px) {
   
   
  
    .box-6-cut-img {
      width: 300px;
    }
    .card-2-down h4,
    .card-6-sub h4 {
      font-size: 19px;
    }
  }
`;

const About = () => {
  const dispatch = useDispatch();
  const { aboutObject, serviceObject } = useSelector((state) => state.content);
  console.log(aboutObject);
  const [activeLink, setActiveLink] = useState("");

  const about = aboutObject?.data?.about;
  const history = aboutObject?.data?.history;
  const marqueeText = aboutObject?.data?.marqueeText;
  const ourValues = aboutObject?.data?.ourValues;
  const threegrids = aboutObject?.data?.threegrids;
  const whyUs = aboutObject?.data?.whyUs;

  const service = serviceObject?.data?.service

 const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(fetcAboutpage());
  }, [dispatch]);

   useEffect(() => {
      dispatch(fetchServices());
    }, [dispatch]);

  useEffect(() => {
    if (aboutObject) {
      setActiveLink(history?.values[0]?.year);
    }
  }, [aboutObject]);

  const activeHistory = activeLink
    ? history?.values?.find((item) => item?.year === activeLink)
    : null;

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  return (
    <AboutRap>
      <div className="about-1 containers">
        <div className="about-1-upper">
          <h6 className="upper-p">{about?.small_title}</h6>
          <h1>
            {" "}
            {about?.main_title?.split(" ").map((word, index, arr) =>
              index >= arr.length - 3 ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              )
            )}
          </h1>
        </div>
        <img
          src={`https://backoffice.holybrookstransportation.com/${about?.banner}`}
          alt=""
        />
      </div>
      <div className="about-2 containers">
        <div className="about-2-upper">
          <div className="about-2-upper-left">
            <h6 className="upper-p">{ourValues?.headings?.small_title}</h6>
            <h2>
              {ourValues?.headings?.main_title
                ?.split(" ")
                .map((word, index, arr) => {
                  const targetIndexes = [arr.length - 3, arr.length - 3]; // 3rd & 2nd to last
                  return targetIndexes.includes(index) ? (
                    <span key={index} style={{ color: "#b4e717" }}>
                      {word}{" "}
                    </span>
                  ) : (
                    word + " "
                  );
                })}
            </h2>
          </div>
          <p>{ourValues?.headings?.description}</p>
        </div>
        <div className="about-2-down">
          {ourValues?.values?.map((item) => (
            <div className="about-2-card">
              <div className="about-2-card-circle">
                <i
                  style={{
                    fontSize: "20px",
                   
                  }}
                  class={item?.icon}
                ></i>
                </div>
              <div className="card-2-down">
                <h4>{item?.title}</h4>
                <p>{item?.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="about-3">
        <div className="about-3-upper containers">
          <h6 className="upper-p">{history?.headings?.small_title}</h6>
          <h2>
            {history?.headings?.main_title?.split(" ").map((word, index, arr) =>
              index >= arr.length - 1 ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              )
            )}
          </h2>
        </div>
        <div
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundImage: ` url(https://backoffice.holybrookstransportation.com/${activeHistory?.banner})`,
          }}
          className="about-3-down containers"
        >
          <div className="about-3-card">
            <div className="card-3-upper">
              <div className="card-3-upper-left">
                <h6 className="upper-p">{activeHistory?.year}</h6>
                <h3>{activeHistory?.title}</h3>
              </div>
              <img className="card-3-img" src="/images/icon-3.png" alt="" />
            </div>
            <p>{activeHistory?.description}</p>
          </div>
          <div className="about-3-Links">
            {history?.values?.map((item) => (
              <Link
                className={`link ${
                  activeLink === `${item.year}` ? "active" : ""
                }`}
                onClick={() => handleLinkClick(item?.year)}
              >
                {item?.year}
              </Link>
            ))}
          </div>
        </div>
      </div> */}
      <div className="about-4 containers">
        <div className="about-4-left">
          <div className="left-4-upper">
            <h6 className="upper-p">{whyUs?.small_title}</h6>
            <h2>
              {whyUs?.main_title?.split(" ").map((word, index, arr) => {
                const targetIndexes = [arr.length - 3, arr.length - 2]; // 3rd & 2nd to last
                return targetIndexes.includes(index) ? (
                  <span key={index} style={{ color: "#b4e717" }}>
                    {word}{" "}
                  </span>
                ) : (
                  word + " "
                );
              })}
            </h2>
          </div>
          <div className="left-4-down">
            <a
              href={whyUs?.first_btn_link}
              className="left-4-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {whyUs?.first_btn_title}
            </a>
            <div className="left-4-circle">
              <Icon
                width="14px"
                height="14px"
                icon="mdi:arrow-top-right"
                
              />
            </div>
          </div>
        </div>
        <div className="about-4-right">
          <div className="right-4-circle">
            <i
              style={{
                color: "#1c4b42",
                fontSize: "30px",
               
              }}
              class={whyUs?.icon}
            ></i>
          </div>
          <p>{whyUs?.content}</p>
        </div>
      </div>
      <div className="containers">
        <div className="about-5 ">
          {service?.services?.map((item) => (
            <Link
              to={`/services/details/${item?.id}`}
              className="about-5-link"
              
            >
              {item?.main_title}
              <div className="about-5-circle">
                <Icon
                  width="14px"
                  height="14px"
                  icon="mdi:arrow-top-right"
                  style={{ color: " #B4E717" }}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="about-6 containers">
        <div className="about-6-card">
          <img className="icon-6-img" src="/images/icon-1.png" alt="" />
          <div className="card-6-middle">
            <p>{threegrids?.content}</p>
            <div className="card-6-inner">
              <img
                className="person-img"
                src={`https://backoffice.holybrookstransportation.com/${threegrids?.image}`}
                alt=" "
              />
              <div className="card-6-sub">
                <h4>{threegrids?.name}</h4>
                <h5>{threegrids?.name_title}</h5>
              </div>
            </div>
          </div>
          <div className="card-6-down">
            <a
              href={threegrids?.first_btn_link}
              className="left-4-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {threegrids?.first_btn_title}
            </a>
            <div className="left-4-circle">
              <Icon
                width="14px"
                height="14px"
                icon="mdi:arrow-top-right"
               
              />
            </div>
          </div>
        </div>
        <img
          className="about-6-image"
          alt=""
          src={`https://backoffice.holybrookstransportation.com/${threegrids?.banner}`}
        />
        <div className="about-6-box">
          <h4>{threegrids?.main_title}</h4>
          <div className="box-6-down">
            <img src="/images/icon-3.png" alt="" />
            <p>{threegrids?.small_title}</p>
          </div>
          <img className="box-6-cut-img" src="/images/cut-3.png" alt="" />
        </div>
      </div>
    </AboutRap>
  );
};

export default About;
